module.exports = __webpack_public_path__ + "assets/pipedrive.eb575366.svg";